import PropTypes from 'prop-types';
import React from 'react';

import ActionsMenuButton from '@components/common/ActionsMenuButton';
import MenuItem from '@components/common/MenuItem';

const UploadsListActionsMenu = ({actions = []}) => {
  return (
    <ActionsMenuButton target="Uploads list" tooltipTitle="More">
      {actions.map(action => (
        <MenuItem
          key={action.label}
          label={action.label}
          icon={action.icon}
          onClick={action.onClick}
        />
      ))}
    </ActionsMenuButton>
  );
};

UploadsListActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
};

export default UploadsListActionsMenu;
